// Open external links in a new tab
document.addEventListener('DOMContentLoaded', function() {
    const anchorLinks = document.querySelectorAll('a');

    anchorLinks.forEach(function(link) {
        const host = window.location.hostname;
        const href = link.href;
        
        if (!href) return;

        if (!href.includes(host) && !href.startsWith('javascript') && !href.startsWith('tel') && !href.startsWith('mailto')) {
            link.setAttribute('target', '_blank');
        }
    });
});